import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import type { ReactNode } from "react";

type DeleteModalProps = {
  title: string;
  onConfirm: () => void;
  article: string;
  additionalText?: ReactNode;
};

export function showDeleteModal({ title, onConfirm, article, additionalText }: DeleteModalProps) {
  modals.openConfirmModal({
    title: `${title} löschen`,
    children: (
      <>
        <Text>{`Möchten Sie wirklich ${article} ${title} löschen?`}</Text>
        {additionalText}
      </>
    ),
    labels: { confirm: "Löschen", cancel: "Abbrechen" },
    confirmProps: { color: "red" },
    onConfirm: onConfirm,
  });
}
